import React, { useState, useEffect } from "react";
import { Layout as AntLayout } from "antd";
import { useSelector } from "react-redux";
import Sidebar from "./Components/Sidebar/Sidebar";
import MobileSidebar from "./Components/Sidebar/MobileSidebar";
import Header from "./Components/Header/Header";

// Import your CSS files
import "./assets/css/poppinsfont.css";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/vendors/font-awesome/css/font-awesome.min.css";
import "./assets/css/argon-dashboard.min.css";
import "./assets/css/style.css";

const { Content } = AntLayout;

const Layout = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const headerHeight = 64;
  const sidebarWidth = 251;
  const collapsedSidebarWidth = 0;

  // Check if user has role_Id 7 (beverage coordinator)
  const isBeverageCoordinator = user && user.role_Id === 7;

  const toggleCollapsed = () => {
    if (isMobile || isBeverageCoordinator) {
      setMobileMenuOpen(!mobileMenuOpen);
    } else {
      setCollapsed(!collapsed);
    }
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Handle responsive behavior
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024; // Changed from 768 to 1024 to include tablets
      setIsMobile(mobile);

      if (mobile) {
        setCollapsed(true);
        setMobileMenuOpen(false); // Close mobile menu on resize
      } else {
        setCollapsed(false);
        setMobileMenuOpen(false); // Close mobile menu when switching to desktop
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <AntLayout style={{ minHeight: "100vh" }}>
      {/* Fixed Header */}
      <AntLayout.Header
        style={{
          padding: 0,
          height: headerHeight,
          lineHeight: `${headerHeight}px`,
          background: "#043f6e",
          position: "fixed",
          zIndex: 1001,
          width: "100%",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        }}
      >
        <Header
          toggleCollapsed={toggleCollapsed}
          collapsed={isMobile || isBeverageCoordinator ? true : collapsed}
        />
      </AntLayout.Header>

      {/* Mobile Sidebar Modal - for mobile users or beverage coordinators */}
      {(isMobile || isBeverageCoordinator) && (
        <MobileSidebar isOpen={mobileMenuOpen} onClose={closeMobileMenu} />
      )}

      {/* Desktop Sidebar - only render for desktop users who are not beverage coordinators */}
      {!isMobile && !isBeverageCoordinator && (
        <div
          id="custom-sidebar"
          style={{
            width: collapsed ? 0 : sidebarWidth,
            position: "fixed",
            top: `${headerHeight}px`,
            bottom: 0,
            left: 0,
            background: "#fff",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            overflowY: "auto",
            zIndex: 1000,
            transition: "width 0.2s",
            opacity: collapsed ? 0 : 1,
            pointerEvents: collapsed ? "none" : "auto",
          }}
        >
          <Sidebar collapsed={collapsed} />
        </div>
      )}

      {/* Main Content */}
      <AntLayout
        style={{
          marginLeft:
            isMobile || isBeverageCoordinator
              ? 0
              : collapsed
              ? 0
              : sidebarWidth,
          marginTop: headerHeight,
          transition: "margin-left 0.3s ease",
        }}
      >
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            background: "#fff",
            borderRadius: "8px",
            minHeight: 280,
          }}
        >
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
